import { commonIcons } from '@apps-common/config/icons'
import { UNIT_STATUS_CANCELLED } from '@apps-common/config/unit-filter'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { useIonModal } from '@ionic/react'
import { ControlModifyModal } from '../../../pages/controls/pages/modify/modals'

interface IProps {
  unitStatus: string
  unitId: string
  isActivated?: boolean
}

export const NoControlsAddButton = ({ unitStatus, unitId, isActivated = true }: IProps) => {
  const [present, dismiss] = useIonModal(ControlModifyModal, {
    componentProps: {
      unitId
    },
    onDismiss: (data: string, role: string) => dismiss(data, role),
    enableBackdropDismiss: true
  })

  return (
    <button
      aria-label='no-controls-add-button'
      type='button'
      disabled={unitStatus === UNIT_STATUS_CANCELLED.value || !isActivated}
      className='relative w-full pt-[100%] hover:opacity-80 disabled:opacity-40 rounded-[30px] flex items-center justify-start gap-[0px] bg-surface text-text'
      onClick={() =>
        present({
          enterAnimation: modalSlideUpEnterAnimation,
          leaveAnimation: modalSlideUpLeaveAnimation
        })
      }
    >
      <div className='absolute top-0 left-0 flex flex-col items-center justify-center w-full h-[100%] gap-[5px] sm:gap-[10px]'>
        <div className='grow flex items-end justify-center w-full rounded-[40px] text-center'>
          <div className=' w-[40px] h-[40px] flex items-center justify-center p-[3px] rounded-full bg-surface-2'>
            <div className='absolute'>
              <div className='w-full h-[100%] rounded-[50%] flex items-center justify-center'>
                <commonIcons.add />
              </div>
            </div>
          </div>
        </div>

        <p className='grow uppercase text-[0.65rem]  sm:text-[0.7rem] leading-[0.8rem] jost text-center'>
          Add new
          <br />
          control
        </p>
      </div>
    </button>
  )
}
